import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import NationalTaxServiceCredentialsForm from '../../../components/forms/NationalTaxServiceCredentialsForm';
import { FORM_OUTLINED_INPUT_PROPS } from '../../../theme/constants/outlined-input';

const TermsCredentialsStep = ({ onCompleted, source }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="column" spacing={8}>
      <Typography
        color="gray.main"
        fontWeight={600}
        variant="medium_1"
      >
        {`Ingresa con la clave de ${t('National Tax Service acronym')} de la empresa y comienza a simular tu financiamiento`}
      </Typography>
      <Box maxWidth={800} width="100%" alignSelf="center">
        <NationalTaxServiceCredentialsForm
          autocomplete
          source={source}
          mainStackSpacing={6}
          onCompleted={onCompleted}
          buttonText="REGISTRAR"
          successMessage="Credenciales ingresadas con éxito. Aceptando términos..."
          closeDialogOnSuccess={false}
          signTyc={false}
          nationalIdentifierInputProps={{
            placeholder: `Ingresa tu ${t('National identifier').toLowerCase()}`,
            ...FORM_OUTLINED_INPUT_PROPS,
          }}
          passwordInputProps={{
            placeholder: `Ingresa tu ${t('Credential Password').toLowerCase()}`,
            ...FORM_OUTLINED_INPUT_PROPS,
          }}
          buttonProps={{ size: 'large' }}
        />
      </Box>
    </Stack>
  );
};

TermsCredentialsStep.propTypes = {
  onCompleted: PropTypes.func,
  source: PropTypes.string,
};

TermsCredentialsStep.defaultProps = {
  onCompleted: () => {},
  source: null,
};

export default TermsCredentialsStep;
